import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		gray: {
			700: '#1f2733'
		},
		primary: {
			500: 'rgba(4,23,72,0.9)',
			600: '#0057d9',
		}
	},
	styles: {
		global: (props) => ({
			body: {
				bg: mode('white', 'gray.800')(props),
				fontFamily: "'Roboto', sans-serif"
			},
			html: {
				fontFamily: "'Roboto', sans-serif"
			}
		})
	}
};
